export enum PRODUCT_KIND_NAME {
  SavingAccount = 'Savings Account',
  CurrentAccount = 'Current Account',
  DebitAccount = 'Debit Card',
  CreditCard = 'Credit Card',
  LoanAccount = 'Loan',
  TermDepositAccount = 'Term Deposit',
}

export enum PRODUCT_KIND {
    KIND1 = 'kind1',
    KIND2 = 'kind2',
    KIND4 = 'kind4',
    KIND5 = 'kind5',
    KIND6 = 'kind6',
  }
  